import React from "react";

export default function BrandStep3({

    form,

    updateField

}) {

    return (

        <div>

            <h2
                style={{
                    marginBottom: 8
                }}
            >
                Brand Identity
            </h2>

            <p
                style={{
                    color: "#777",
                    marginBottom: 30
                }}
            >
                Tell customers about your business.
            </p>

            {/* Brand Description */}

            <div
                style={{
                    marginBottom: 20
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Brand Description *
                </label>

                <textarea
                    rows={5}
                    value={form.description}
                    onChange={(e) =>
                        updateField(
                            "description",
                            e.target.value
                        )
                    }
                    placeholder="Describe your brand, products, services and values..."
                    style={{
                        width: "100%",
                        padding: 12,
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        resize: "vertical"
                    }}
                />

            </div>

            {/* Mission */}

            <div
                style={{
                    marginBottom: 20
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Mission
                </label>

                <textarea
                    rows={3}
                    value={form.mission}
                    onChange={(e) =>
                        updateField(
                            "mission",
                            e.target.value
                        )
                    }
                    placeholder="What is your mission?"
                    style={{
                        width: "100%",
                        padding: 12,
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        resize: "vertical"
                    }}
                />

            </div>

            {/* Vision */}

            <div
                style={{
                    marginBottom: 20
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Vision
                </label>

                <textarea
                    rows={3}
                    value={form.vision}
                    onChange={(e) =>
                        updateField(
                            "vision",
                            e.target.value
                        )
                    }
                    placeholder="Where do you see your brand in the future?"
                    style={{
                        width: "100%",
                        padding: 12,
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        resize: "vertical"
                    }}
                />

            </div>

            {/* Founded Year */}

            <div
                style={{
                    marginBottom: 20
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Founded Year
                </label>

                <input
                    type="number"
                    min="1800"
                    max="2100"
                    value={form.foundedYear}
                    onChange={(e) =>
                        updateField(
                            "foundedYear",
                            e.target.value
                        )
                    }
                    placeholder="2026"
                    style={{
                        width: "100%",
                        padding: 12,
                        border: "1px solid #ddd",
                        borderRadius: 8
                    }}
                />

            </div>

        </div>

    );

}